/**
 * True when rich-text HTML has no real text content — i.e. it's empty or only
 * the editor's empty-paragraph placeholder (`<p></p>`, `<p><br></p>`). Shared
 * by the wrap-up flow, the skip-note gate, and the skip handler so they agree
 * on what "no note" means.
 */
export const isRichTextEmpty = (html: string): boolean => html.replace(/<[^>]+>/g, '').trim().length === 0;
